import { Button as MuiButton, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import { say } from '@/james-playground/aa-family-claim/claim/asks';
import { START_DATE } from '@/james-playground/aa-family-claim/claim/cards/cards.content';
import { CardShell } from '@/james-playground/aa-family-claim/claim/cards/parts';
import { type CardProps } from '@/james-playground/aa-family-claim/claim/cards/types';
import {
  dateText,
  known,
  str,
} from '@/james-playground/aa-family-claim/claim/cards/values';

/**
 * Protecting the start date (spec 9). Ringing DWP for a claim form keeps the
 * day of the call as the start, if the claim arrives within 6 weeks. "I've
 * rung them" records today. "Later" leaves the date open, so the hub keeps the
 * reminder.
 */
const StartDateCard = ({
  ask,
  facts,
  voice: v,
  onSubmit,
  onSkip,
  today = new Date(),
}: CardProps & { today?: Date }) => {
  const id = ask.entries[0];
  const rang = str(known(facts, id));

  return (
    <CardShell
      label={say(ask.title, v)}
      onSkip={onSkip}
      actions={
        rang ? (
          <MuiButton
            variant='contained'
            fullWidth
            onClick={() => onSubmit({ [id]: rang }, START_DATE.keep)}
          >
            {START_DATE.keep}
          </MuiButton>
        ) : (
          <>
            <MuiButton
              variant='contained'
              fullWidth
              onClick={() =>
                onSubmit({ [id]: dateText(today) }, START_DATE.rangReply)
              }
            >
              {START_DATE.rang}
            </MuiButton>
            <MuiButton
              variant='outlined'
              fullWidth
              onClick={() => onSubmit({}, START_DATE.laterReply)}
            >
              {START_DATE.later}
            </MuiButton>
          </>
        )
      }
    >
      {rang ? (
        <Typography variant='body1'>{START_DATE.already(rang)}</Typography>
      ) : (
        <Stack spacing={1.5}>
          <Typography variant='body2'>{say(START_DATE.body, v)}</Typography>
          <Stack spacing={0.5}>
            <MuiButton
              variant='outlined'
              href={START_DATE.tel}
              startIcon={<Icon icon='phone' fontSize={14} />}
              sx={{ alignSelf: 'flex-start' }}
            >
              {START_DATE.call}
            </MuiButton>
            <Typography variant='caption'>{START_DATE.hours}</Typography>
          </Stack>
        </Stack>
      )}
    </CardShell>
  );
};

StartDateCard.displayName = 'StartDateCard';
export default StartDateCard;
